/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EventTypeCreateDTO } from '../models';
// @ts-ignore
import type { EventTypeResponseDTO } from '../models';
// @ts-ignore
import type { EventTypeUpdateDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageEventTypeResponseDTO } from '../models';
/**
 * EventTypesApi - axios parameter creator
 * @export
 */
export const EventTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new event type in the current organization. Requires \'event_type:write\' permission.
         * @summary Create Event Type
         * @param {EventTypeCreateDTO} eventTypeCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventTypeApiV1EventTypesPost: async (eventTypeCreateDTO: EventTypeCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventTypeCreateDTO' is not null or undefined
            assertParamExists('createEventTypeApiV1EventTypesPost', 'eventTypeCreateDTO', eventTypeCreateDTO)
            const localVarPath = `/api/v1/event-types/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventTypeCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new event type in the current organization. Requires \'event_type:write\' permission.
         * @summary Create Event Type
         * @param {EventTypeCreateDTO} eventTypeCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventTypeApiV1EventTypesPost_1: async (eventTypeCreateDTO: EventTypeCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventTypeCreateDTO' is not null or undefined
            assertParamExists('createEventTypeApiV1EventTypesPost_1', 'eventTypeCreateDTO', eventTypeCreateDTO)
            const localVarPath = `/api/v1/event-types/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventTypeCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an event type from the organization. Requires \'event_type:write\' permission.
         * @summary Delete Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventTypeApiV1EventTypesEventTypeIdDelete: async (eventTypeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('deleteEventTypeApiV1EventTypesEventTypeIdDelete', 'eventTypeId', eventTypeId)
            const localVarPath = `/api/v1/event-types/{event_type_id}`
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an event type from the organization. Requires \'event_type:write\' permission.
         * @summary Delete Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventTypeApiV1EventTypesEventTypeIdDelete_2: async (eventTypeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('deleteEventTypeApiV1EventTypesEventTypeIdDelete_2', 'eventTypeId', eventTypeId)
            const localVarPath = `/api/v1/event-types/{event_type_id}`
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific event type by ID. Requires \'event_type:view\' permission.
         * @summary Get Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypeApiV1EventTypesEventTypeIdGet: async (eventTypeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('getEventTypeApiV1EventTypesEventTypeIdGet', 'eventTypeId', eventTypeId)
            const localVarPath = `/api/v1/event-types/{event_type_id}`
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific event type by ID. Requires \'event_type:view\' permission.
         * @summary Get Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypeApiV1EventTypesEventTypeIdGet_3: async (eventTypeId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('getEventTypeApiV1EventTypesEventTypeIdGet_3', 'eventTypeId', eventTypeId)
            const localVarPath = `/api/v1/event-types/{event_type_id}`
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all event types in the current user\'s organization. Requires \'event_type:view\' permission.
         * @summary List Event Types
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventTypesApiV1EventTypesGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/event-types/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all event types in the current user\'s organization. Requires \'event_type:view\' permission.
         * @summary List Event Types
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventTypesApiV1EventTypesGet_4: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/event-types/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an event type\'s information. Requires \'event_type:write\' permission.
         * @summary Update Event Type
         * @param {string} eventTypeId 
         * @param {EventTypeUpdateDTO} eventTypeUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTypeApiV1EventTypesEventTypeIdPatch: async (eventTypeId: string, eventTypeUpdateDTO: EventTypeUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('updateEventTypeApiV1EventTypesEventTypeIdPatch', 'eventTypeId', eventTypeId)
            // verify required parameter 'eventTypeUpdateDTO' is not null or undefined
            assertParamExists('updateEventTypeApiV1EventTypesEventTypeIdPatch', 'eventTypeUpdateDTO', eventTypeUpdateDTO)
            const localVarPath = `/api/v1/event-types/{event_type_id}`
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventTypeUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an event type\'s information. Requires \'event_type:write\' permission.
         * @summary Update Event Type
         * @param {string} eventTypeId 
         * @param {EventTypeUpdateDTO} eventTypeUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTypeApiV1EventTypesEventTypeIdPatch_5: async (eventTypeId: string, eventTypeUpdateDTO: EventTypeUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventTypeId' is not null or undefined
            assertParamExists('updateEventTypeApiV1EventTypesEventTypeIdPatch_5', 'eventTypeId', eventTypeId)
            // verify required parameter 'eventTypeUpdateDTO' is not null or undefined
            assertParamExists('updateEventTypeApiV1EventTypesEventTypeIdPatch_5', 'eventTypeUpdateDTO', eventTypeUpdateDTO)
            const localVarPath = `/api/v1/event-types/{event_type_id}`
                .replace(`{${"event_type_id"}}`, encodeURIComponent(String(eventTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventTypeUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventTypesApi - functional programming interface
 * @export
 */
export const EventTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new event type in the current organization. Requires \'event_type:write\' permission.
         * @summary Create Event Type
         * @param {EventTypeCreateDTO} eventTypeCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventTypeApiV1EventTypesPost(eventTypeCreateDTO: EventTypeCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventTypeApiV1EventTypesPost(eventTypeCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.createEventTypeApiV1EventTypesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new event type in the current organization. Requires \'event_type:write\' permission.
         * @summary Create Event Type
         * @param {EventTypeCreateDTO} eventTypeCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventTypeApiV1EventTypesPost_1(eventTypeCreateDTO: EventTypeCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventTypeApiV1EventTypesPost_1(eventTypeCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.createEventTypeApiV1EventTypesPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an event type from the organization. Requires \'event_type:write\' permission.
         * @summary Delete Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventTypeApiV1EventTypesEventTypeIdDelete(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventTypeApiV1EventTypesEventTypeIdDelete(eventTypeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.deleteEventTypeApiV1EventTypesEventTypeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an event type from the organization. Requires \'event_type:write\' permission.
         * @summary Delete Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventTypeApiV1EventTypesEventTypeIdDelete_2(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventTypeApiV1EventTypesEventTypeIdDelete_2(eventTypeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.deleteEventTypeApiV1EventTypesEventTypeIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific event type by ID. Requires \'event_type:view\' permission.
         * @summary Get Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTypeApiV1EventTypesEventTypeIdGet(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventTypeApiV1EventTypesEventTypeIdGet(eventTypeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.getEventTypeApiV1EventTypesEventTypeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific event type by ID. Requires \'event_type:view\' permission.
         * @summary Get Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventTypeApiV1EventTypesEventTypeIdGet_3(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventTypeApiV1EventTypesEventTypeIdGet_3(eventTypeId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.getEventTypeApiV1EventTypesEventTypeIdGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all event types in the current user\'s organization. Requires \'event_type:view\' permission.
         * @summary List Event Types
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEventTypesApiV1EventTypesGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEventTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEventTypesApiV1EventTypesGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.listEventTypesApiV1EventTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all event types in the current user\'s organization. Requires \'event_type:view\' permission.
         * @summary List Event Types
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEventTypesApiV1EventTypesGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEventTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEventTypesApiV1EventTypesGet_4(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.listEventTypesApiV1EventTypesGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an event type\'s information. Requires \'event_type:write\' permission.
         * @summary Update Event Type
         * @param {string} eventTypeId 
         * @param {EventTypeUpdateDTO} eventTypeUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventTypeApiV1EventTypesEventTypeIdPatch(eventTypeId: string, eventTypeUpdateDTO: EventTypeUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventTypeApiV1EventTypesEventTypeIdPatch(eventTypeId, eventTypeUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.updateEventTypeApiV1EventTypesEventTypeIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an event type\'s information. Requires \'event_type:write\' permission.
         * @summary Update Event Type
         * @param {string} eventTypeId 
         * @param {EventTypeUpdateDTO} eventTypeUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventTypeApiV1EventTypesEventTypeIdPatch_5(eventTypeId: string, eventTypeUpdateDTO: EventTypeUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventTypeApiV1EventTypesEventTypeIdPatch_5(eventTypeId, eventTypeUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventTypesApi.updateEventTypeApiV1EventTypesEventTypeIdPatch_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventTypesApi - factory interface
 * @export
 */
export const EventTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventTypesApiFp(configuration)
    return {
        /**
         * Create a new event type in the current organization. Requires \'event_type:write\' permission.
         * @summary Create Event Type
         * @param {EventTypeCreateDTO} eventTypeCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventTypeApiV1EventTypesPost(eventTypeCreateDTO: EventTypeCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeResponseDTO> {
            return localVarFp.createEventTypeApiV1EventTypesPost(eventTypeCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new event type in the current organization. Requires \'event_type:write\' permission.
         * @summary Create Event Type
         * @param {EventTypeCreateDTO} eventTypeCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventTypeApiV1EventTypesPost_1(eventTypeCreateDTO: EventTypeCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeResponseDTO> {
            return localVarFp.createEventTypeApiV1EventTypesPost_1(eventTypeCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an event type from the organization. Requires \'event_type:write\' permission.
         * @summary Delete Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventTypeApiV1EventTypesEventTypeIdDelete(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEventTypeApiV1EventTypesEventTypeIdDelete(eventTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an event type from the organization. Requires \'event_type:write\' permission.
         * @summary Delete Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventTypeApiV1EventTypesEventTypeIdDelete_2(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEventTypeApiV1EventTypesEventTypeIdDelete_2(eventTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific event type by ID. Requires \'event_type:view\' permission.
         * @summary Get Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypeApiV1EventTypesEventTypeIdGet(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeResponseDTO> {
            return localVarFp.getEventTypeApiV1EventTypesEventTypeIdGet(eventTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific event type by ID. Requires \'event_type:view\' permission.
         * @summary Get Event Type
         * @param {string} eventTypeId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventTypeApiV1EventTypesEventTypeIdGet_3(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeResponseDTO> {
            return localVarFp.getEventTypeApiV1EventTypesEventTypeIdGet_3(eventTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all event types in the current user\'s organization. Requires \'event_type:view\' permission.
         * @summary List Event Types
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventTypesApiV1EventTypesGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageEventTypeResponseDTO> {
            return localVarFp.listEventTypesApiV1EventTypesGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all event types in the current user\'s organization. Requires \'event_type:view\' permission.
         * @summary List Event Types
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEventTypesApiV1EventTypesGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageEventTypeResponseDTO> {
            return localVarFp.listEventTypesApiV1EventTypesGet_4(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an event type\'s information. Requires \'event_type:write\' permission.
         * @summary Update Event Type
         * @param {string} eventTypeId 
         * @param {EventTypeUpdateDTO} eventTypeUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTypeApiV1EventTypesEventTypeIdPatch(eventTypeId: string, eventTypeUpdateDTO: EventTypeUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeResponseDTO> {
            return localVarFp.updateEventTypeApiV1EventTypesEventTypeIdPatch(eventTypeId, eventTypeUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an event type\'s information. Requires \'event_type:write\' permission.
         * @summary Update Event Type
         * @param {string} eventTypeId 
         * @param {EventTypeUpdateDTO} eventTypeUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventTypeApiV1EventTypesEventTypeIdPatch_5(eventTypeId: string, eventTypeUpdateDTO: EventTypeUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<EventTypeResponseDTO> {
            return localVarFp.updateEventTypeApiV1EventTypesEventTypeIdPatch_5(eventTypeId, eventTypeUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventTypesApi - object-oriented interface
 * @export
 * @class EventTypesApi
 * @extends {BaseAPI}
 */
export class EventTypesApi extends BaseAPI {
    /**
     * Create a new event type in the current organization. Requires \'event_type:write\' permission.
     * @summary Create Event Type
     * @param {EventTypeCreateDTO} eventTypeCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public createEventTypeApiV1EventTypesPost(eventTypeCreateDTO: EventTypeCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).createEventTypeApiV1EventTypesPost(eventTypeCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new event type in the current organization. Requires \'event_type:write\' permission.
     * @summary Create Event Type
     * @param {EventTypeCreateDTO} eventTypeCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public createEventTypeApiV1EventTypesPost_1(eventTypeCreateDTO: EventTypeCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).createEventTypeApiV1EventTypesPost_1(eventTypeCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an event type from the organization. Requires \'event_type:write\' permission.
     * @summary Delete Event Type
     * @param {string} eventTypeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public deleteEventTypeApiV1EventTypesEventTypeIdDelete(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).deleteEventTypeApiV1EventTypesEventTypeIdDelete(eventTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an event type from the organization. Requires \'event_type:write\' permission.
     * @summary Delete Event Type
     * @param {string} eventTypeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public deleteEventTypeApiV1EventTypesEventTypeIdDelete_2(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).deleteEventTypeApiV1EventTypesEventTypeIdDelete_2(eventTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific event type by ID. Requires \'event_type:view\' permission.
     * @summary Get Event Type
     * @param {string} eventTypeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public getEventTypeApiV1EventTypesEventTypeIdGet(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).getEventTypeApiV1EventTypesEventTypeIdGet(eventTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific event type by ID. Requires \'event_type:view\' permission.
     * @summary Get Event Type
     * @param {string} eventTypeId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public getEventTypeApiV1EventTypesEventTypeIdGet_3(eventTypeId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).getEventTypeApiV1EventTypesEventTypeIdGet_3(eventTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all event types in the current user\'s organization. Requires \'event_type:view\' permission.
     * @summary List Event Types
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public listEventTypesApiV1EventTypesGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).listEventTypesApiV1EventTypesGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all event types in the current user\'s organization. Requires \'event_type:view\' permission.
     * @summary List Event Types
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public listEventTypesApiV1EventTypesGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).listEventTypesApiV1EventTypesGet_4(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an event type\'s information. Requires \'event_type:write\' permission.
     * @summary Update Event Type
     * @param {string} eventTypeId 
     * @param {EventTypeUpdateDTO} eventTypeUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public updateEventTypeApiV1EventTypesEventTypeIdPatch(eventTypeId: string, eventTypeUpdateDTO: EventTypeUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).updateEventTypeApiV1EventTypesEventTypeIdPatch(eventTypeId, eventTypeUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an event type\'s information. Requires \'event_type:write\' permission.
     * @summary Update Event Type
     * @param {string} eventTypeId 
     * @param {EventTypeUpdateDTO} eventTypeUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypesApi
     */
    public updateEventTypeApiV1EventTypesEventTypeIdPatch_5(eventTypeId: string, eventTypeUpdateDTO: EventTypeUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return EventTypesApiFp(this.configuration).updateEventTypeApiV1EventTypesEventTypeIdPatch_5(eventTypeId, eventTypeUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

